import { CASE_001, characterById, evidenceById } from '../case/case001';
import type { GameState } from './types';
import { getCourtEventBeat } from './courtEvents';
import { isTrialReady } from './reducer';

export function renderGameToText(state: GameState, nearby: string | null): string {
  const statement = CASE_001.statements[state.activeStatementIndex];
  const liveAgent = state.activeCharacterId ? state.yuragi.agents[state.activeCharacterId] : null;
  const payload = {
    game: 'HŌTEI',
    case: CASE_001.id,
    phase: state.phase,
    chapter: state.chapter,
    location: state.location,
    coordinateSystem: 'origin=center floor; +x=east/right; +y=up; +z=south/toward counsel gallery',
    overlay: state.overlay,
    player: {
      position: state.player.position.map((value) => Number(value.toFixed(2))),
      yaw: Number(state.player.yaw.toFixed(2)),
      pitch: Number(state.player.pitch.toFixed(2)),
    },
    nearby,
    activeCharacter: state.activeCharacterId
      ? characterById[state.activeCharacterId]?.name
      : null,
    activeStatement: state.phase === 'trial' && statement ? statement.text : null,
    activePressure: statement ? state.pressureByStatement[statement.id] ?? 0 : 0,
    discoveredEvidence: state.discoveredEvidenceIds.map((id) => evidenceById[id]?.title ?? id),
    contradictionsFound: state.contradictionsFound.length,
    witnessesQuestioned: state.questionedCharacterIds,
    trialReady: isTrialReady(state),
    credibility: state.credibility,
    focus: state.focus,
    theory: state.theory,
    revealElapsedMs: state.revealElapsedMs,
    outcome: state.outcome,
    profile: {
      counselId: state.profile.counselId,
      callsign: state.profile.callsign,
      level: state.profile.level,
      xp: state.profile.xp,
    },
    courtEvent: state.courtEvent
      ? {
          id: state.courtEvent.id,
          elapsedMs: state.courtEvent.elapsedMs,
          beat: getCourtEventBeat(state.courtEvent),
        }
      : null,
    yuragi: {
      protocol: state.yuragi.protocol,
      blockHeight: state.yuragi.height,
      couplingK: Number(state.yuragi.couplingK.toFixed(2)),
      herdSync: Number(state.yuragi.syncOrder.toFixed(3)),
      transitionHash: state.yuragi.transitionHash,
      activeAgent: liveAgent ? {
        id: liveAgent.id,
        tick: liveAgent.state.n,
        decision: liveAgent.decision,
        stance: liveAgent.stance,
        motion: liveAgent.motion,
        arousal: Number(liveAgent.arousal.toFixed(3)),
        trust: Number(liveAgent.trust.toFixed(3)),
        experienceEvents: liveAgent.eventSeq,
        knownFacts: Object.keys(liveAgent.knowledge).length,
        stateHash: liveAgent.stateHash,
      } : null,
    },
  };
  return JSON.stringify(payload);
}
